import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Space,
  Popconfirm,
  Card,
} from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import { tipoContratoService } from '../services/api';

const modeloOptions = [
  { label: 'Global', value: 'GLOBAL' },
  { label: 'Parcial', value: 'PARCIAL' },
];

const TipoContratosList = () => {
  const [registros, setRegistros] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form] = Form.useForm();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await tipoContratoService.list();
      setRegistros(response.data);
    } catch (error) {
      const errorMsg = error.response?.data?.detail 
        ? (typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : JSON.stringify(error.response.data.detail))
        : 'Erro ao carregar tipos de contrato';
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCreate = () => {
    setEditingId(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingId(record.id);
    form.setFieldsValue(record);
    setIsModalVisible(true);
  };

  const handleSave = async (values) => {
    try {
      if (editingId) {
        await tipoContratoService.update(editingId, values);
        message.success('Tipo de contrato atualizado com sucesso');
      } else {
        await tipoContratoService.create(values);
        message.success('Tipo de contrato criado com sucesso');
      }
      setIsModalVisible(false);
      form.resetFields();
      fetchData();
    } catch (error) {
      const errorMsg = error.response?.data?.detail 
        ? (typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : JSON.stringify(error.response.data.detail))
        : 'Erro ao salvar tipo de contrato';
      message.error(errorMsg);
    }
  };

  const handleDelete = async (id) => {
    try {
      await tipoContratoService.delete(id);
      message.success('Tipo de contrato deletado com sucesso');
      fetchData();
    } catch (error) {
      const errorMsg = error.response?.data?.detail 
        ? (typeof error.response.data.detail === 'string' 
          ? error.response.data.detail 
          : JSON.stringify(error.response.data.detail))
        : 'Erro ao deletar tipo de contrato';
      message.error(errorMsg);
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
    { title: 'Tipo de Contrato', dataIndex: 'tipo_contrato', key: 'tipo_contrato' },
    {
      title: 'Modelo de Repasse',
      dataIndex: 'modelo_de_repasse',
      key: 'modelo_de_repasse',
      render: (value) => (value === 'GLOBAL' ? 'Global' : 'Parcial'),
    },
    {
      title: 'Ações',
      key: 'actions',
      width: 170,
      render: (_, record) => (
        <Space>
          <Button type="primary" icon={<EditOutlined />} size="small" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="Confirmar exclusão"
            description="Tem certeza que deseja deletar este tipo de contrato?"
            onConfirm={() => handleDelete(record.id)}
            okText="Sim"
            cancelText="Não"
          >
            <Button type="primary" danger icon={<DeleteOutlined />} size="small">
              Deletar
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Card
        title="Tipos de Contrato"
        extra={
          <Space>
            <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
              Novo
            </Button>
            <Button icon={<ReloadOutlined />} onClick={fetchData} loading={loading}>
              Atualizar
            </Button>
          </Space>
        }
      >
        <Table
          columns={columns}
          dataSource={registros}
          loading={loading}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      </Card>

      <Modal
        title={editingId ? 'Editar Tipo de Contrato' : 'Novo Tipo de Contrato'}
        open={isModalVisible}
        onOk={() => form.submit()}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
        }}
        okText={editingId ? 'Atualizar' : 'Criar'}
        cancelText="Cancelar"
      >
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item
            name="tipo_contrato"
            label="Tipo de Contrato"
            rules={[
              { required: true, message: 'Informe o tipo de contrato' },
              { min: 1, max: 100, message: 'Use entre 1 e 100 caracteres' },
            ]}
          >
            <Input placeholder="Ex: Franquia, Parceria" />
          </Form.Item>

          <Form.Item
            name="modelo_de_repasse"
            label="Modelo de Repasse"
            rules={[{ required: true, message: 'Selecione o modelo de repasse' }]}
          >
            <Select options={modeloOptions} placeholder="Selecione" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default TipoContratosList;
